import React from 'react';
import Column from '@amzn/meridian/column';
import ViewRates from '../../common/ssd/ViewRates';
import NavigationButtons from '../../../commonComponents/NavigationButtons';

const VerifyRates = ({ currentUser, plan, setPlan, onGoBack, onGoNext, onCancel }) => {
  return (
    <Column width="100%">
      <ViewRates currentUser={currentUser} isEditable={true} plan={plan} setPlan={setPlan} />
      <NavigationButtons onBack={onGoBack} onCancel={onCancel} onNext={onGoNext} showCancel={true} />
    </Column>
  );
};

export default VerifyRates;
